(() => {
 'use strict';
 const banner = document.getElementById('dtw-global-countdown');
 if (!banner) return;
 const start = Number(banner.dataset.start), end = Number(banner.dataset.end);
 const label = banner.querySelector('[data-dtw-global-label]');
 const offer = banner.querySelector('[data-dtw-global-offer]');
 const days = banner.querySelector('[data-dtw-global-days]');
 const hours = banner.querySelector('[data-dtw-global-hours]');
 const minutes = banner.querySelector('[data-dtw-global-minutes]');
 let interval;
 function update() {
  const now = Date.now();
  if (now >= end) { banner.hidden = true; clearInterval(interval); return; }
  const active = now >= start;
  const left = Math.max(0, Math.floor(((active ? end : start) - now) / 1000));
  label.textContent = active ? banner.dataset.active : banner.dataset.upcoming;
  if (active) offer.textContent = banner.dataset.offer;
  days.textContent = Math.floor(left / 86400);
  hours.textContent = String(Math.floor(left % 86400 / 3600)).padStart(2, '0');
  minutes.textContent = String(Math.floor(left % 3600 / 60)).padStart(2, '0');
 }
 update();
 if (!banner.hidden) interval = setInterval(() => { if (!document.hidden) update(); }, 1000);
 document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
 window.addEventListener('pageshow', update);
})();
